<template>
  <NumericPad
    v-if="open"
    :open="true"
    :value="value"
    :title="title"
    :mode="mode"
    :allow-decimal="allowDecimal"
    :placeholder="placeholder"
    :max-length="maxLength"
    @input="onPadInput"
    @close="close"
  />
</template>

<script>
import NumericPad from '@/components/NumericPad'
import {
  isTouchModeEnabled,
  isTouchNumberInput,
  onTouchModeChange,
  touchPadAllowDecimal,
  touchPadModeFor,
} from '@/utils/touchMode'

export default {
  name: 'TouchNumberHost',
  components: { NumericPad },
  data() {
    return {
      open: false,
      value: '',
      title: '',
      mode: 'number',
      allowDecimal: false,
      placeholder: '0',
      maxLength: 12,
      target: null,
      unsub: null,
    }
  },
  mounted() {
    document.addEventListener('pointerdown', this.onPointerDown, true)
    document.addEventListener('focusin', this.onFocusIn, true)
    this.unsub = onTouchModeChange(() => {
      if (!isTouchModeEnabled()) this.close()
    })
  },
  beforeDestroy() {
    document.removeEventListener('pointerdown', this.onPointerDown, true)
    document.removeEventListener('focusin', this.onFocusIn, true)
    if (this.unsub) this.unsub()
  },
  methods: {
    resolveInput(node) {
      if (!node) return null
      if (node.tagName === 'INPUT') return node
      if (node.closest) {
        const field = node.closest('.v-text-field, .v-input')
        if (field) {
          const input = field.querySelector('input')
          if (input) return input
        }
      }
      return null
    },
    shouldHandle(input) {
      return isTouchModeEnabled() && isTouchNumberInput(input)
    },
    onPointerDown(event) {
      if (!isTouchModeEnabled()) return
      if (event.button != null && event.button !== 0) return
      const input = this.resolveInput(event.target)
      if (!this.shouldHandle(input)) return
      event.preventDefault()
      event.stopPropagation()
      this.openFor(input)
    },
    onFocusIn(event) {
      if (!isTouchModeEnabled()) return
      const input = this.resolveInput(event.target)
      if (!this.shouldHandle(input)) return
      // Клавиатуру ОС блокируем: сразу blur и открываем нашу модалку
      input.blur()
      this.openFor(input)
    },
    openFor(input) {
      if (!input) return
      this.target = input
      this.mode = touchPadModeFor(input)
      this.allowDecimal = this.mode === 'number' && touchPadAllowDecimal(input)
      this.value = String(input.value ?? '')
      this.title = input.getAttribute('aria-label')
        || input.getAttribute('placeholder')
        || this.$t('common.touchPad')
      this.placeholder = input.getAttribute('placeholder') || '0'
      const max = Number(input.getAttribute('maxlength') || input.dataset.touchMax)
      this.maxLength = Number.isFinite(max) && max > 0 ? max : (this.mode === 'phone' ? 11 : 12)
      this.open = true
    },
    onPadInput(next) {
      this.value = next
      const input = this.target
      if (!input) return

      const setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value')
      if (setter && setter.set) setter.set.call(input, next)
      else input.value = next

      input.dispatchEvent(new Event('input', { bubbles: true }))
      input.dispatchEvent(new Event('change', { bubbles: true }))
    },
    close() {
      this.open = false
      this.target = null
    },
  },
}
</script>
